import { render, staticRenderFns } from "./BaseInputNumber.vue?vue&type=template&id=635a42da&"
import script from "./BaseInputNumber.vue?vue&type=script&lang=js&"
export * from "./BaseInputNumber.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputNumber.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports